import { CollectionSummary } from '@qkindex/contracts';

export const inventoryKey = (collectionId: string, recordId: string): string =>
  JSON.stringify([collectionId, recordId]);

/** Decode a UI identity, never an authorization source. Free-text filters are not keys. */
export function scopedRecordCollectionId(value: string): string | undefined {
  try {
    const key: unknown = JSON.parse(value);
    return Array.isArray(key) &&
      key.length === 2 &&
      key.every((part) => typeof part === 'string' && part.length > 0)
      ? key[0]
      : undefined;
  } catch {
    return undefined;
  }
}

/** UI identity only. Record and foreign-key IDs always retain their stored values. */
export const recordKey = (record: {
  id: string;
  collectionId?: string;
}): string =>
  record.collectionId
    ? inventoryKey(record.collectionId, record.id)
    : record.id;

export type ScopedRecord<T> = T & {
  collectionId: string;
  collectionName: string;
};
export const scopeRecord = <T>(
  record: T,
  collection: Pick<CollectionSummary, 'collectionId' | 'name'>,
): ScopedRecord<T> => ({
  ...record,
  collectionId: collection.collectionId,
  collectionName: collection.name,
});
